import React from "react";
import isMobile from '../utils/ismobile'
import styled from 'styled-components'
import PageWrapper from "./pageWrapper";
import { breakpoint } from 'styled-components-breakpoint';

const FooterWrapper = styled.footer`
    width: 100%;
    background-color:${props => props.theme.black1};
    z-index: 100;
    position: relative;
    padding: 5px 10px;
    span{
        color: #fff;
    }

`
function Footer(props) {


    return(
        <FooterWrapper>
            <PageWrapper>
                <span>(c) Truffelhond.nl</span>
            </PageWrapper>
        </FooterWrapper>
    )
}

export default Footer;